import { gql } from "@/__generated__/gql";

export const FUN_FACTS = gql(`
query FunFacts($id: ID!, $before:String, $after:String, $first:Int, $last:Int) {
  node(id: $id) {
    ... on Student {
      id
      profileAnswers(
        before: $before, 
        after:$after, 
        first:$first, 
        last:$last, 
        filter:FUN_FACTS, 
        ordering:{ direction:DESC, field:UPDATED_AT }
){
        pageInfo{
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges{
          cursor
          node{
            question{
              text
            }
            text
          }
        }
      }
    }
  }
}
`);
